import { render } from "./AboutFilmstro.vue?vue&type=template&id=290e09b2&scoped=true"
const script = {}

import "./AboutFilmstro.vue?vue&type=style&index=0&id=290e09b2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-290e09b2"]])

export default __exports__